import { AxiosError, AxiosRequestConfig, AxiosResponse, AxiosTransformer } from 'axios';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getToken } from '../auth/UserService';
import { getLocalUser } from '../auth/LocalAuthService';
import i18n from 'i18next';
import { getApiBaseUrl } from '../config/apiBase';

const api = axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
        common: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    },
});

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = getToken();

    if (token && token !== '') {
        config.headers.common = {
            ...config.headers.common,
            Authorization: `Bearer ${token}`,
        };
    }

    const localUser = getLocalUser();
    if (localUser?.userId) {
        config.headers.common = {
            ...config.headers.common,
            'X-Local-User-Id': localUser.userId,
        };
    }

    return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    console.error(`[response error] [${JSON.stringify(error)}]`);

    return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
    // Do something with response data
    if (response.status === 201) {
        // Do something
    }

    if (response.status === 202) {
        // Do something
    }

    return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
    if (error.response && error.response.status === 400) {
        toast.error(i18n.t(`b:${error.response.data.errorMessage}`), { className: 'error-toast' });
    }

    if (error.response && error.response.status === 500) {
        // Do something
    }

    console.error(`[response error] [${JSON.stringify(error)}]`);

    return Promise.reject(error);
};

export const defaultTransformers = (): AxiosTransformer[] => {
    const { transformRequest } = axios.defaults;
    if (!transformRequest) {
        return [];
    } else if (transformRequest instanceof Array) {
        return transformRequest;
    } else {
        return [transformRequest];
    }
};

api.interceptors.response.use(onResponse, onResponseError);
api.interceptors.request.use(onRequest, onRequestError);

export default api;
